import { useEffect, useState } from "react";

const defaultConfig = {
  name: "Coupon",
  discount_type: "percentage",
  discount_value: 10,
  unique_code: "ZOLA-10%",
  user_email: "user@example.com",
  is_used: false,
  show_qr_code: true,
  show_logo: true,
  thank_you_title: "THANK YOU",
  thank_you_subtitle: "for being a great customer",
  background_color: "#ffffff",
  text_color: "#000000",
  startDate: "",
  endDate: "",
  duration: "",
  redemption_area: "",
  title_color: "#000000",
  title_size: "text-3xl",
  subtitle_color: "#6b7280",
  subtitle_size: "text-sm",
  discount_color: "#9333ea",
  discount_size: "text-5xl",
  note: "on your next order with us",
  note_color: "#6b7280",
  note_size: "text-sm",
  validity_color: "#9ca3af",
  validity_size: "text-xs",
  code_text_color: "#7c3aed",
  code_bg_color: "#ffffff",
  code_border_color: "#7c3aed",
  code_border_style: "dashed",
};


const useCouponConfig = () => {
  const [config, setConfig] = useState(defaultConfig);
  const [hasPreview, setHasPreview] = useState(false); // <-- New flag

  // Fetch from API on mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          "https://zola.technology/api/company/coupon-page/get/",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!res.ok) throw new Error("Fetch failed");

        const data = await res.json();
        if (Object.keys(data).length > 0) {
          setConfig((prev) => ({ ...prev, ...data }));
          setHasPreview(true); // <-- Mark that preview exists
        }
      } catch (error) {
        console.warn("Using default config due to error:", error.message);
      }
    };

    fetchConfig();
  }, []);

  // Calculate duration
  useEffect(() => {
    const { startDate, endDate } = config;
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
      setConfig((prev) => ({
        ...prev,
        duration:
          diff >= 0 ? `${diff} day${diff !== 1 ? "s" : ""}` : "Invalid range",
      }));
    } else {
      setConfig((prev) => ({ ...prev, duration: "" }));
    }
  }, [config.startDate, config.endDate]);

  const handleChange = (field, value) => {
    if (field.startsWith("coupon.")) {
      const key = field.split(".")[1];
      setConfig((prev) => ({
        ...prev,
        coupon: {
          ...prev.coupon,
          [key]: value,
        },
      }));
    } else {
      setConfig((prev) => {
        const updated = { ...prev, [field]: value };
        if (field === "discount_value" || field === "discount_type") {
          const prefix = "ZOLA";
          updated.unique_code =
            updated.discount_type === "percentage"
              ? `${prefix}-${updated.discount_value}%`
              : `${prefix}-${updated.discount_value}USD`;
        }
        return updated;
      });
    }
  };

  const handleToggle = (field) => {
    setConfig((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return { config, handleChange, handleToggle, hasPreview };
  ;
};

export default useCouponConfig;
